<template>
    <div id="app">
        <div style="margin-bottom: 40px;">
            <el-row>
                <el-col :span="7" style="font-weight: bold;">
                    <div style="margin-left: 10px;">
                        <el-text style="font-size: medium">教会</el-text>
                        <br />
                        <el-text style="font-size: large;letter-spacing:6px;">神乐老师</el-text>
                        <br />
                        <el-text style="font-size: small;">的高贵圣徒们</el-text>
                    </div>
                </el-col>
                <!-- <el-col :span="2">
            </el-col> -->
                <el-col :span="17" style="text-align:right;">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :ellipsis="false" @select="handleSelect" style="font-size: default ;margin-top: 20px;" align="right">
                        <el-col :span="8">
                            <router-link to="/" style="text-decoration:none;color:inherit;">
                                <el-menu-item index="0">阅读</el-menu-item>
                            </router-link>
                        </el-col>
                        <el-col :span="8">
                            <router-link to="/classic" style="text-decoration:none;color:inherit;">
                                <el-menu-item index="1">经典</el-menu-item>
                            </router-link>
                        </el-col>
                        <el-col :span="6">
                            <router-link to="/welfare" style="text-decoration:none;color:inherit;">
                                <el-menu-item index="2">福利</el-menu-item>
                            </router-link>
                        </el-col>
                        <el-col :span="2">
                        </el-col>
                    </el-menu>
                    <el-row style="font-size: medium;">
                        <!--  <el-col :span="8"><router-link to="/" >阅读</router-link></el-col>
             <el-col :span="8"><router-link to="/classic">经典</router-link></el-col>
             <el-col :span="8"><router-link to="/welfare">福利</router-link></el-col> -->
                    </el-row>
                </el-col>
            </el-row>
            <!-- <el-card shadow="always" style="text-align:right;">
            </el-card> -->
        </div>
        <router-view></router-view>
        <footer class="site-footer">
            <div class="site-footer-information">
                <strong>神乐老师网站</strong>
                <p>面向粉丝的内容与会员网站。登录会员中心，查看神乐币记录、参与任务及管理申请。</p>
                <nav aria-label="网站信息">
                    <router-link to="/about">关于本站</router-link>
                    <router-link to="/privacy">隐私政策</router-link>
                    <router-link to="/terms">服务条款</router-link>
                    <router-link to="/member">会员中心</router-link>
                </nav>
            </div>
            <el-row>
                <el-col :span="1"></el-col>
                <el-col :span="20" style="font-size: xx-small">© 2019 THE CHURCH OF SLLS OF GAOGUI SAINTS.元基基元科技有限公司.</el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </footer>
        <!-- <router-link to="/">shouye</router-link>
     |
    <router-link to="/TestHome">TestHome</router-link>
     |
    <router-link to="/TestUser">TestUser</router-link> -->
        <!-- <router-view></router-view> -->
    </div>
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <Home msg="Welcome to Your Vue.js App"/> -->
</template>
<script>
// import HelloWorld from './components/HelloWorld.vue'
// import Home from './views/Home.vue'

export default {
    name: 'App',
    components: {
        // HelloWorld
        // home
    }
}
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    text-align: center;
    font-size: 14px;


    /*白色：#FFFFFF
黑色：#000000
暗灰色：#242424
浅灰色：#EFEFF4
深灰色：#8E8E93
蓝色：#0A84FF
绿色：#30D158
紫色：#BF5AF2
橙色：#FF9F0A
粉红色：#FF2D55*/
}

.site-footer {
    margin-top: 72px;
    padding: 30px 0 24px;
    border-top: 1px solid #e8edeb;
    text-align: left;
    color: #68766f;
}

.site-footer-information {
    width: 91.6667%;
    margin: 0 auto 24px;
    font-size: 13px;
    line-height: 1.8;
}

.site-footer-information strong {
    color: #33483e;
    font-size: 14px;
}

.site-footer-information p { margin: 6px 0 12px; }
.site-footer-information nav, .policy-bottom-links { display: flex; flex-wrap: wrap; gap: 12px 24px; }
.site-footer-information a, .policy-page a { color: #267c57; text-underline-offset: 3px; }
.site-footer-information a:hover, .policy-page a:hover { color: #185b3e; }
.site-footer a:focus-visible, .policy-page a:focus-visible { outline: 2px solid #267c57; outline-offset: 4px; border-radius: 2px; }

.policy-page {
    box-sizing: border-box;
    width: calc(100% - 48px);
    max-width: 860px;
    margin: 0 auto;
    text-align: left;
    color: #40534a;
    font-size: 15px;
    line-height: 1.95;
    overflow-wrap: anywhere;
}

.policy-header { padding: 20px 0 26px; border-bottom: 1px solid #e5ece8; }
.policy-eyebrow { margin: 0 0 10px; color: #608372; font-size: 12px; letter-spacing: 1px; }
.policy-page h1 { margin: 0; color: #283f33; font-size: clamp(27px, 4vw, 36px); font-weight: 600; line-height: 1.4; }
.policy-date { color: #75857c; font-size: 12px; margin: 12px 0 0; }
.policy-intro { margin: 18px 0 0; font-size: 16px; }
.policy-page section { margin-top: 32px; }
.policy-page h2 { font-size: 19px; color: #2e4839; margin: 0 0 12px; line-height: 1.55; font-weight: 600; }
.policy-page section p { margin: 0 0 14px; }
.policy-page ul { padding-left: 22px; margin: 0 0 14px; }
.policy-page li { margin-bottom: 12px; }
.policy-primary-link { display: inline-block; margin: 2px 0 4px; font-weight: 600; }
.policy-bottom-links { border-top: 1px solid #e5ece8; padding-top: 22px; margin-top: 38px; font-size: 14px; }

@media (max-width: 600px) {
    .site-footer { margin-top: 48px; }
    .site-footer-information nav, .policy-bottom-links { gap: 10px 18px; }
    .policy-page { width: calc(100% - 32px); font-size: 14px; line-height: 1.9; }
    .policy-header { padding-top: 0; }
    .policy-intro { font-size: 15px; }
    .policy-page section { margin-top: 27px; }
}
</style>
